// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'underscore',
    '../models/ReportSavedModel',
    '../../app/models/MabinsoCollection'
], (Globals, _, ReportSavedModel, MabinsoCollection) => {
    const ReportSavedCollection = MabinsoCollection.extend({
        url() { return Globals.baseUrl + 'reportsSaved/reportSaved'; },
        model: ReportSavedModel
    });
    return ReportSavedCollection;
});



// WEBPACK FOOTER //
// ./src/components/report/models/ReportSavedCollection.js